import React, { useCallback, useContext, useMemo, useRef, useState } from 'react';
import UserContext from '../../../common/utils/getContext';
import Form from '../../external_form/ExternalForm';
import { getFormData, getFormStyles } from './initData';
import { checkUserToken } from '../utils';
import T from '../../../common/components/T';
import { LangContext } from '../../../common/decorators/Language';
import { API_SERVER_URL, setLanguageForEmail } from '../../../common/utils/utils';
import VerifyEmail from '../components/confirm/email/VerifyEmail/VerifyEmail';
import { getData } from '../../../common/utils/router';

const Register = ({ afterConfirm, setStepData }) => {
    const { translation } = useContext(LangContext) || {};
    const { setUserToken, setAlertData, lang } = useContext(UserContext);
    const formStyles = useMemo(() => getFormStyles(), []);
    const [sponsorData, setSponsorData] = useState({});
    const interval = useRef();
    const [errors, setErrors] = useState(null);

    const afterSend = useCallback(
        (data, _, setAllowedSend, userData) => {
            if (data?.data?.email_verification_enabled) {
                return setStepData({
                    component: VerifyEmail,
                    props: {
                        setStepData,
                        data: { ...data, userData }
                    },
                    layoutStyle: 'authBlock_lg'
                });
            }
            if (data?.data?.token) {
                setLanguageForEmail(data?.data?.token, lang);
            }
            checkUserToken(data, afterConfirm, setAllowedSend, setUserToken, setAlertData, translation);
        },
        [afterConfirm, lang, setAlertData, setStepData, setUserToken, translation]
    );

    const fields = useMemo(() => getFormData(translation, sponsorData), [translation, sponsorData]);

    const searchFunc = useCallback(
        async (text) => {
            getData(`/api/v1/sponsors/${text}`, false, lang, false, false, false, true)
                .then((res) => {
                    if (res?.data) {
                        setSponsorData(res);
                        setErrors((state) => {
                            const newState = { ...state };
                            delete newState.sponsor_username;
                            return newState;
                        });
                    } else if (res?.status === 404) {
                        setErrors((e = {}) => ({
                            ...e,
                            sponsor_username: [
                                <T
                                    key='0'
                                    textName='registration_fields_sponsor_username_not_found'
                                    defaultStr='Пользователь с таким ID не найден.'
                                    page='/authentication'
                                />
                            ]
                        }));
                    }
                })
                .catch(console.warn);
        },
        [lang]
    );

    const search = useCallback(
        (text) => {
            clearTimeout(interval.current);
            interval.current = setTimeout(async () => {
                await searchFunc(text);
            }, 500);
        },
        [searchFunc]
    );

    return (
        <Form
            data={{ data: fields }}
            captcha={{ alias: 'user::register' }}
            sendData={{
                url: `${API_SERVER_URL}/api/v1/register`,
                afterSenderSuccess: afterSend
            }}
            funcs={{
                sponsor_username: {
                    onChange: (text) => {
                        search(text);
                        return text;
                    }
                },
                country_id: {
                    onChange: (value) => value?.value || value
                }
            }}
            formStyles={formStyles}
            buttonText={<T textName='register_enter_button' defaultStr='Зарегистрироваться' page='/authentication' />}
            hoverColor={{
                hover: 'var(--blueColor)',
                blur: 'var(--greyDarkColor)'
            }}
            message={{ error: false }}
            // components={{
            //     after: <HasAccountComponent />
            // }}
            groupFormDataError={errors}
        />
    );
};
export default Register;
